import { Component } from '@angular/core';
import {DisparoAutomatizadoComponent} from '../../disparo-automatizado.component';

@Component({
  selector: 'app-disparo-automatizado-programacoes',
  standalone: true,
  imports: [DisparoAutomatizadoComponent],
  templateUrl: './disparo-automatizado-programacoes.component.html',
  styleUrl: './disparo-automatizado-programacoes.component.css'
})
export class DisparoAutomatizadoProgramacoesComponent {

}
